
export function FrGroupBox(props) {
    return(
        <div style={{display: 'inline-block', borderWidth: 1, borderColor: '#083c7c', borderStyle:'solid', marginBottom: 15, borderRadius: 6, paddingBottom: 6, paddingRight: 6, paddingLeft: 12, marginRight: 6}}>
            <label id='groupboxLabel' style={{position: 'relative', top: -11, paddingInline: 5, marginLeft: 5, backgroundColor: '#f7efef', }}>
                {props.label}
            </label>
            
            <br/>

            {props.children}
        </div>
    )
}